<template>
  <w-icon-wrapper
    icon-name='work-inspection-icon'
    :width="24.12"
    :height="24"
    viewBox="0 0 24.12 24"
  >
    <g
      id="_110_Inspektion"
      data-name="110_Inspektion"
      transform="translate(-1772 -928.21)"
    >
      <path
        id="Pfad_1"
        data-name="Pfad 1"
        d="M23.82,20.4l-3.67-3.67-.22-.22c.08-.12.15-.25.22-.37a5.159,5.159,0,0,0,.64-2.49,5.093,5.093,0,0,0-.64-2.48,4.933,4.933,0,0,0-.86-1.15,4.4,4.4,0,0,0-.39-.35,4.947,4.947,0,0,0-2-.99,2.768,2.768,0,0,0-.5-.1,4.616,4.616,0,0,0-.74-.06,5.135,5.135,0,0,0,0,10.27,4.616,4.616,0,0,0,.74-.06,2.768,2.768,0,0,0,.5-.1,5.1,5.1,0,0,0,1.62-.71l1.63,1.63,2.26,2.27a1.024,1.024,0,0,0,.71.29,1,1,0,0,0,.7-.29.99.99,0,0,0,0-1.42m-5.46-5.16a2.919,2.919,0,0,1-.48.63,3.05,3.05,0,0,1-.98.65,2.213,2.213,0,0,1-.5.15,3.208,3.208,0,0,1-2.96-.8,3.138,3.138,0,0,1,0-4.43,3.083,3.083,0,0,1,2.22-.92,2.642,2.642,0,0,1,.74.1,2.24,2.24,0,0,1,.5.16,3.026,3.026,0,0,1,.98.66l.04.04a3.134,3.134,0,0,1,.44,3.76"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_2"
        data-name="Pfad 2"
        d="M16.9,5.36V2.21H13.45v.03a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1V2.21H2v20H16.9v-.85a1,1,0,0,1,2,0v2.85H0V.21H18.9V5.36a1,1,0,0,1-2,0"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_3"
        data-name="Pfad 3"
        d="M15.27,6.24a1,1,0,0,1-1,1H4.77a1,1,0,1,1,0-2h9.5a.99.99,0,0,1,1,1"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_4"
        data-name="Pfad 4"
        d="M8.65,11.36H4.775a1,1,0,0,1,0-2H8.65a1,1,0,0,1,0,2"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_5"
        data-name="Pfad 5"
        d="M8.65,14.86H4.775a1,1,0,1,1,0-2H8.65a1,1,0,0,1,0,2"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_6"
        data-name="Pfad 6"
        d="M9.65,18.735H4.775a1,1,0,1,1,0-2H9.65a1,1,0,0,1,0,2"
        transform="translate(1772 928)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconInspection' };
</script>
